export default __webpack_public_path__ + "static/media/quickbooks_logo.d631ad2c.svg";